function initializeCustomTabs(scope = document) {
  const sections = scope.querySelectorAll('.featured-tabs-section[data-section-id]');

  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const buttons = section.querySelectorAll(".tab-button");
    const tabs = section.querySelectorAll(".tab-panel");
    const tabNav = section.querySelector(".tab-buttons.flickity-nav");

    let tabNavFlickity = null;

    function getSlidesCount(desktop, tablet, mobile) {
      if (window.innerWidth > 1200) return desktop;
      if (window.innerWidth > 768) return tablet;
      return mobile;
    }

    function getProductSlidesToShow() {
      return getSlidesCount(
        parseInt(section.dataset.productColumnsDesktop || 3),
        parseInt(section.dataset.productColumnsTablet || 2),
        parseInt(section.dataset.productColumnsMobile || 1)
      );
    }

    function getNavSlidesToShow() {
      return getSlidesCount(
        parseInt(section.dataset.tabColumnsDesktop || 4),
        parseInt(section.dataset.tabColumnsTablet || 3),
        parseInt(section.dataset.tabColumnsMobile || 2)
      );
    }

    function initializeTabNavFlickity() {
      if (!tabNav) return;

      if (tabNavFlickity) {
        tabNavFlickity.destroy();
      }

      tabNavFlickity = new Flickity(tabNav, {
        cellAlign: "left",
        contain: true,
        freeScroll: false,
        prevNextButtons: true,
        pageDots: false,
        groupCells: getNavSlidesToShow()
      });
    }

    function updateProgressBarAndArrows(flkty, carousel) {
      const progressBar = carousel.closest(".tab-panel")?.querySelector(".progress-bar");
      const prev = carousel.querySelector(".flickity-prev-next-button.flickity-previous");
      const next = carousel.querySelector(".flickity-prev-next-button.flickity-next");

      if (!flkty || !progressBar) return;

      const totalPages = Math.ceil(flkty.slides.length);
      const currentPage = Math.floor(flkty.selectedIndex);

      const progress = totalPages > 0 ? (currentPage + 1) / totalPages : 1;
      progressBar.style.width = `${Math.min(progress * 100, 100)}%`;

      if (prev) prev.disabled = currentPage <= 0;
      if (next) next.disabled = currentPage >= totalPages - 1;
    }

    function initializeFlickity(carousel) {
      if (!carousel) return;

      const existingFlickity = Flickity.data(carousel);
      if (existingFlickity) existingFlickity.destroy();

      const slidesToShow = getProductSlidesToShow();

      const flkty = new Flickity(carousel, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        groupCells: slidesToShow
      });

      flkty.on("ready", () => updateProgressBarAndArrows(flkty, carousel));
      flkty.on("change", () => updateProgressBarAndArrows(flkty, carousel));

      updateProgressBarAndArrows(flkty, carousel);
    }

    function activateTab(index) {
      const tab = tabs[index];
      if (!tab) {
        console.warn(`Tab at index ${index} not found in section ${section.dataset.sectionId}`);
        return;
      }

      tabs.forEach((t, i) => {
        t.style.display = i === index ? "block" : "none";
      });

      buttons.forEach((btn, i) => {
        btn.classList.toggle("active", i === index);
      });

      const carousel = tab.querySelector(".flickity-carousel");
      if (!carousel) return;

      const flkty = Flickity.data(carousel);
      if (flkty) {
        flkty.resize();
        updateProgressBarAndArrows(flkty, carousel);
      } else {
        setTimeout(() => initializeFlickity(carousel), 100);
      }
    }

    // Initial setup
    initializeTabNavFlickity();
    if (tabs.length > 0) activateTab(0);

    buttons.forEach((btn, index) => {
      btn.addEventListener("click", () => activateTab(index));
    });

    let lastWidth = window.innerWidth;
    let resizeTimeout;

    window.addEventListener("resize", () => {
      if (window.innerWidth === lastWidth) return;

      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initializeTabNavFlickity();
        if (tabNavFlickity) {
          tabNavFlickity.resize();
          tabNavFlickity.reloadCells();
        }

        const activeTab = section.querySelector(".tab-panel[style*='display: block']");
        const carousel = activeTab?.querySelector(".flickity-carousel");
        if (carousel) {
          const flkty = Flickity.data(carousel);
          if (flkty) {
            flkty.resize();
            updateProgressBarAndArrows(flkty, carousel);
          } else {
            initializeFlickity(carousel);
          }
        }

        lastWidth = window.innerWidth;
      }, 250);
    });
  });
}

// Event bindings
document.addEventListener("DOMContentLoaded", () => initializeCustomTabs());
document.addEventListener("shopify:section:load", (e) => initializeCustomTabs(e.target));
document.addEventListener("shopify:section:select", (e) => initializeCustomTabs(e.target));
document.addEventListener("shopify:load", () => initializeCustomTabs());

function initAnkTabs(scope = document) {
  const sections = scope.querySelectorAll('.ank-featured-collection[data-section-id]');

  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    const sectionId = section.getAttribute("id");
    if (!sectionId) return;

    setTimeout(() => section.classList.add("loadetabs"), 150);

    function getSlidesToShow() {
      const desktop = parseInt(section.dataset.productColumnsDesktop || 3);
      const tablet = parseInt(section.dataset.productColumnsTablet || 2);
      const mobile = parseInt(section.dataset.productColumnsMobile || 1);

      if (window.innerWidth > 1200) return desktop;
      if (window.innerWidth > 768) return tablet;
      return mobile;
    }

    let flkty;

    function initializeFlickity() {
      const flickityCarousel = section.querySelector(".ank-fc-flickity-carousel");
      const progressBar = section.querySelector(".progress-bar");

      if (!flickityCarousel || !progressBar) return;

      const slidesToShow = getSlidesToShow();
      const cells = flickityCarousel.querySelectorAll(".carousel-item");

      if (cells.length <= slidesToShow) {
        if (progressBar) progressBar.style.width = "100%";
        return;
      }

      if (flkty) {
        flkty.destroy();
        flkty = null;
      }

      flkty = new Flickity(flickityCarousel, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        prevNextButtons: true,
        pageDots: false,
        autoPlay: false,
        freeScroll: false,
        draggable: true,
        groupCells: slidesToShow,
      });

      const prevButton = flickityCarousel.querySelector(".flickity-prev-next-button.previous");
      const nextButton = flickityCarousel.querySelector(".flickity-prev-next-button.next");

      function getTotalPages() {
        return Math.ceil(flkty.slides.length);
      }

      function getCurrentPage() {
        return Math.floor(flkty.selectedIndex);
      }

      function updateProgress() {
        const totalPages = getTotalPages();
        const currentPage = getCurrentPage();
        const progress = totalPages > 0 ? (currentPage + 1) / totalPages : 1;
        progressBar.style.width = `${Math.min(progress * 100, 100)}%`;
      }

      function updateArrows() {
        const totalPages = getTotalPages();
        const currentPage = getCurrentPage();
        if (prevButton) prevButton.disabled = currentPage <= 0;
        if (nextButton) nextButton.disabled = currentPage >= totalPages - 1;
      }

      flkty.on("ready", () => {
        updateProgress();
        updateArrows();
      });

      flkty.on("change", () => {
        updateProgress();
        updateArrows();
      });

      setTimeout(() => {
        updateProgress();
        updateArrows();
      }, 100);
    }

    // Initial run
    setTimeout(initializeFlickity, 300);

    let lastWidth = window.innerWidth;
    window.addEventListener("resize", function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        initializeFlickity();
      }
    });
  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", () => initAnkTabs());

// Shopify Theme Editor support
document.addEventListener("shopify:section:load", (e) => initAnkTabs(e.target));
document.addEventListener("shopify:section:select", (e) => initAnkTabs(e.target));
document.addEventListener("shopify:load", () => initAnkTabs());


function customerReviews(wrapper) {
  if (!wrapper) return;

  // Modal setup (same as before)...

  // Read more buttons (same as before)...

  const sectionId = wrapper.dataset.sectionId;
  if (!sectionId) return;

  const settings = window["carouselSettings_" + sectionId];
  if (!settings) return;

  const mainSlider = wrapper.querySelector('.slider-main');
  const thumbSlider = wrapper.querySelector('.slider-thumbs');
  if (!mainSlider || !thumbSlider) return;

  // Destroy old Flickity instances
  if (wrapper.flkMain) wrapper.flkMain.destroy();
  if (wrapper.flkThumbs) wrapper.flkThumbs.destroy();

  // Responsive helpers
  const getMainSlidesToShow = () => {
    const width = window.innerWidth;
    if (width > 1200) return settings.slidesDesktop;
    if (width > 768) return settings.slidesTablet;
    return settings.slidesMobile;
  };

  const getThumbSlidesToShow = () => {
    const width = window.innerWidth;
    if (width > 1200) return settings.thumbsDesktop;
    if (width > 768) return settings.thumbsTablet;
    return settings.thumbsMobile;
  };

  const setCellWidth = (cells, count) => {
    cells.forEach(cell => {
      //cell.style.width = (100 / count) + '%';
    });
  };

  const mainSlidesToShow = getMainSlidesToShow();
  const thumbSlidesToShow = getThumbSlidesToShow();

  setCellWidth(mainSlider.querySelectorAll('.slick-slides'), mainSlidesToShow);
  setCellWidth(thumbSlider.querySelectorAll('.swiper-slide'), thumbSlidesToShow);

  wrapper.flkMain = new Flickity(mainSlider, {
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    draggable: true,
    groupCells: 1,
    wrapAround: true,
    selectedAttraction: 0.01,
    friction: 0.15,
  });

  wrapper.flkThumbs = new Flickity(thumbSlider, {
    asNavFor: mainSlider,
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    cellAlign: 'left',
    groupCells: 1,
    focusOnSelect: true,
    wrapAround: true,
  });

  let syncing = false;
  wrapper.flkThumbs.on('select', () => {
    if (syncing) return;
    syncing = true;
    wrapper.flkMain.select(wrapper.flkThumbs.selectedIndex);
    syncing = false;
  });
  wrapper.flkMain.on('select', () => {
    if (syncing) return;
    syncing = true;
    wrapper.flkThumbs.select(wrapper.flkMain.selectedIndex);
    syncing = false;
  });

  // Save counts to wrapper
  wrapper._mainSlidesToShow = mainSlidesToShow;
  wrapper._thumbSlidesToShow = thumbSlidesToShow;
}


// Initialize all sections on the page or inside a container
function initAllCustomerReviews(root = document) {
  const wrappers = root.querySelectorAll('[data-section-id]');
  wrappers.forEach(wrapper => customerReviews(wrapper));
}

// Initial run on DOM ready
document.addEventListener("DOMContentLoaded", () => initAllCustomerReviews());

// Shopify events for dynamic sections
document.addEventListener("shopify:load", () => initAllCustomerReviews());
document.addEventListener("shopify:section:load", e => initAllCustomerReviews(e.target));
document.addEventListener("shopify:section:select", e => initAllCustomerReviews(e.target));

// Global window resize listener (only once)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    // Re-init only if slidesToShow count changed
    document.querySelectorAll('[data-section-id]').forEach(wrapper => {
      const sectionId = wrapper.dataset.sectionId;
      if (!sectionId) return;
      const settings = window["carouselSettings_" + sectionId];
      if (!settings) return;

      const width = window.innerWidth;
      let slidesToShow;
      if (width > 1200) slidesToShow = settings.slidesDesktop;
      else if (width > 768) slidesToShow = settings.slidesTablet;
      else slidesToShow = settings.slidesMobile;

      if (wrapper._slidesToShow !== slidesToShow) {
        customerReviews(wrapper);
      }
    });
  }, 150);
});

function initializeIconTextSliders(root = document) {
  const sections = root.querySelectorAll('[data-icon-text-slider]');

  sections.forEach((section) => {
    const sliderContainer = section.querySelector(".iconTextSlider");
    if (!sliderContainer) return;

    const slidesToShow = parseInt(section.dataset.slides) || 1;
    const enableMobile = section.dataset.enableMobile === "true";

    // Destroy previous Flickity instance if it exists
    if (sliderContainer.flickityInstance) {
      sliderContainer.flickityInstance.destroy();
      sliderContainer.flickityInstance = null;
    }

    // Only enable on mobile if allowed
    if (window.innerWidth > 768 || !enableMobile) return;

    // Initialize Flickity
    const flkty = new Flickity(sliderContainer, {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      freeScroll: false,
      draggable: true,
    });

    sliderContainer.flickityInstance = flkty;

    // Optional: Arrow logic if you add arrows inside .iconTextSlider
    const prevButton = sliderContainer.querySelector(".flickity-prev-next-button.flickity-previous");
    const nextButton = sliderContainer.querySelector(".flickity-prev-next-button.flickity-next");

    function updateArrows() {
      if (!prevButton || !nextButton) return;
      prevButton.disabled = flkty.selectedIndex === 0;
      nextButton.disabled = flkty.selectedIndex >= flkty.slides.length - slidesToShow;
    }

    flkty.on("change", updateArrows);
    updateArrows();
  });
}

// Initialization hooks
document.addEventListener("DOMContentLoaded", () => initializeIconTextSliders());
document.addEventListener("shopify:load", () => initializeIconTextSliders());
document.addEventListener("shopify:section:load", (e) => initializeIconTextSliders(e.target));
document.addEventListener("shopify:section:select", (e) => initializeIconTextSliders(e.target));

// Re-initialize on resize
let lastWidth = window.innerWidth;
window.addEventListener("resize", () => {
  if (window.innerWidth !== lastWidth) {
    lastWidth = window.innerWidth;
    initializeIconTextSliders();
  }
});



